/** Helpers **/
import { callWebservice } from './webserviceCaller';

export default class wsKeywords
{
  constructor(
    selectedFilters,
    loaderID,
    dispatch,
    selectedInstance
  ){
    this.device = selectedFilters.devLoc.deviceValue;
    this.location = selectedFilters.devLoc.countryValue + '|' + selectedFilters.devLoc.cityValue;
    this.loaderID = loaderID;
    this.dispatch = dispatch;
    this.selectedInstance = selectedInstance;
  }

  addKeywords = ( 
    keywords, 
    categories, 
    extractSources,
    callBackFct = null
  ) => 
  {
    this.exec(
      keywords, 
      null,
      categories, 
      'add',
      extractSources,
      callBackFct
    );
  }
  
  updateKeywords = (
    keywords, 
    newLabel,
    categories, 
    extractSources,
    callBackFct = null
  ) => 
  {
    this.exec(
      keywords, 
      newLabel,
      categories, 
      'update',
      extractSources,
      callBackFct
    );
  }
  
  delKeywords = (
    keywords,
    callBackFct = null
  ) => 
  {
    this.exec(
      keywords, 
      null,
      null,
      'remove',
      null,
      callBackFct
    );
  }
  
  exec = (
    keywords, 
    newLabel,
    categories, 
    actionType,
    extractSources,
    callBackFct = null
  ) => 
  {
    callWebservice( 
      this.loaderID,
      actionType + '-keywords',
      actionType + '-keywords',
      this.dispatch,
      this.selectedInstance,
      {
        keywords: keywords, 
        label: newLabel,
        categories: categories,
        device: actionType === 'update' ? [this.device] : this.device,
        location: actionType === 'update' ? [this.location] : this.location,
        extractSources: extractSources
      },
      callBackFct !== null ? {
        function: callBackFct
      } : null
    );
  }
}